import { Component, EventEmitter, Input, Output, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';

@Component({
  selector: 'app-searchable-select',
  templateUrl: './searchable-select.component.html',
  styleUrls: ['./searchable-select.component.scss'],
  standalone: false
})
export class SearchableSelectComponent implements OnInit, OnChanges {

  @Input() items: any[] = [];
  @Input() displayField = '';

  @Output() filteredItemsChange = new EventEmitter<any[]>();

  searchCtrl = new UntypedFormControl('');

  ngOnInit(): void {
    this.searchCtrl.valueChanges.subscribe(value => {
      const search = (value || '').toLowerCase();
      const filtered = this.items.filter(item =>
        String(item[this.displayField] || '')
          .toLowerCase()
          .includes(search)
      );
      this.filteredItemsChange.emit(filtered);
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['items']) {
      this.filteredItemsChange.emit([...this.items]);
    }
  }

  clearSearch(): void {
    this.searchCtrl.setValue('', { emitEvent: false });
    this.filteredItemsChange.emit([...this.items]);
  }
}
